import axios from 'axios';
import miscFunctions from '../helpers/misc-functions';
import Metadata from '../helpers/metadata/Metadata';
import serviceUtil from './serviceUtil';

const DEFAULT_TIMEOUT = 20000;
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

function deleteInventoryItem(itemId, taskId, eventMetadatum) {
  if (!eventMetadatum) {
    eventMetadatum = Metadata.generateMetadatum();
  }
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API + '/inventory_items/' + itemId + '?current_company=' + localStorage.current_company_id,
    timeout: DEFAULT_TIMEOUT,
    headers: {
      ...DEFAULT_HEADERS,
      'Authorization': 'Token token=' + localStorage.token,
    },
    data: {
      event_metadatum: eventMetadatum,
      'task_id': taskId,
    },
  })
  .then(response => {
    return response;
  })
  .catch(error => {
    return serviceUtil.resultForError(error);
  });
}

function getInventoryItem(itemId, options) {
  let request =  process.env.REACT_APP_API + '/inventory_items/' + itemId + '?current_company=' + localStorage.current_company_id;

  return axios({
    method: 'get',
    url: request,
    timeout: DEFAULT_TIMEOUT,
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Content-Type': 'application/json',
      'Accept': '*/*',
      'Authorization': 'Token token=' + localStorage.token,
    },
  }) 
  .then(response => {
    if (response.data.data) {
      let record = miscFunctions.mapApiJson(response.data);
      return record;
    }
  })
  .catch(error => {
    return { error };
  });
}

function createInventoryItem(item, taskId, eventMetadatum) {
  if (!eventMetadatum) {
    eventMetadatum = Metadata.generateMetadatum();
  }
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API + '/inventory_items/?current_company=' + localStorage.current_company_id,
    timeout: DEFAULT_TIMEOUT,
    headers: {
      ...DEFAULT_HEADERS,
      'Authorization': 'Token token=' + localStorage.token,
    },
    data: {
      event_metadatum: eventMetadatum,
      'task_id': taskId,
      'inventory_item': item,
    },
  })
  .then(response => {
    return response;
  })
  .catch(error => {
    return serviceUtil.resultForError(error);
  });
}

function getInventoryItems(project_id, options) {
  // if filtering exists, add to query
  let request =  process.env.REACT_APP_API + '/projects/' + project_id + '/inventory_items?current_company=' + localStorage.current_company_id;

  return axios({
    method: 'get',
    url: request,
    timeout: DEFAULT_TIMEOUT,
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
      'Content-Type': 'application/json',
      'Accept': '*/*',
      'Authorization': 'Token token=' + localStorage.token,
    },
  }) 
  .then(response => {
    return response.data;
  })
  .catch(error => {
    return { error };
  });
}

function updateInventoryItem(item, taskId, eventMetadatum) {
  if (!eventMetadatum) {
    eventMetadatum = Metadata.generateMetadatum();
  }
  return axios({
    method: 'patch',
    url: process.env.REACT_APP_API + '/inventory_items/' + item.id + '?current_company=' + localStorage.current_company_id,
    timeout: DEFAULT_TIMEOUT,
    headers: {
      ...DEFAULT_HEADERS,
      'Authorization': 'Token token=' + localStorage.token,
    },
    data: {
      event_metadatum: eventMetadatum,
      'task_id': taskId,
      'inventory_item': item,
    },
  })
  .then(response => {
    return miscFunctions.mapApiJson(response.data);
  })
  .catch(error => {
    return serviceUtil.resultForError(error);
  });
}

export default {
  deleteInventoryItem,
  getInventoryItems,
  getInventoryItem,
  createInventoryItem,
  updateInventoryItem,
};



// WEBPACK FOOTER //
// ./src/services/inventoryItemService.js